
export const readJson = async (response: Response): Promise<unknown> => response.json();

export const rawField = (value: unknown, key: string): unknown => {
  if (typeof value !== 'object' || value === null) return undefined;
  const raw: unknown = Reflect.get(value, key);
  return raw;
};

export const stringField = (value: unknown, key: string): string | undefined => {
  const raw = rawField(value, key);
  return typeof raw === 'string' && raw !== '' ? raw : undefined;
};

export const numberField = (value: unknown, key: string): number | undefined => {
  const raw = rawField(value, key);
  return typeof raw === 'number' && Number.isFinite(raw) ? raw : undefined;
};

export const booleanField = (value: unknown, key: string): boolean | undefined => {
  const raw = rawField(value, key);
  return typeof raw === 'boolean' ? raw : undefined;
};

export const arrayField = (value: unknown, key: string): unknown[] | undefined => {
  const raw = rawField(value, key);
  return Array.isArray(raw) ? raw : undefined;
};

export const literalField = <T extends string>(
  value: unknown,
  key: string,
  allowed: readonly T[],
): T | undefined => {
  const raw = stringField(value, key);
  return allowed.find((candidate) => candidate === raw);
};

export const numberLiteralField = <T extends number>(
  value: unknown,
  key: string,
  allowed: readonly T[],
): T | undefined => {
  const raw = numberField(value, key);
  return allowed.find((candidate) => candidate === raw);
};

export const nullableStringField = (value: unknown, key: string): string | null => {
  const raw = rawField(value, key);
  return typeof raw === 'string' ? raw : null;
};
